import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface FieldProps {
  label: string;
  value: string;
}
function Field({ label, value }: FieldProps): React.JSX.Element {
  return (
    <Stack>
      <Typography color="text.primary" gutterBottom variant="subtitle2">
        {label}
      </Typography>
      <Typography color="text.secondary" variant="body2">
        {value}
      </Typography>
    </Stack>
  );
}

export default Field;
